:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-column{flex-direction:column;}
:root ._grow-1{flex-grow:1;}
:root ._shrink-0{flex-shrink:0;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._width-10037{width:100%;}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._minH-34px{min-height:34px;}
:root ._minW-34px{min-width:34px;}
:root ._bg-003b9535{background-color:#003b95;}
:root ._aspectRatio-1{aspect-ratio:1;}
:root ._btlr-4px{border-top-left-radius:4px;}
:root ._btrr-4px{border-top-right-radius:4px;}
:root ._bbrr-4px{border-bottom-right-radius:4px;}
:root ._bblr-0px{border-bottom-left-radius:0px;}
:root ._mr-t-space-med104641{margin-right:var(--t-space-medium);}
:root ._ml-t-space-med104641{margin-left:var(--t-space-medium);}